import apiClient from "../../axios/apiClient";

export const getStateList =
  (token, limit = 10, page = 1, search = "", sort = "desc") =>
    async (dispatch) => {
      try {
        dispatch({ type: "GET_STATELIST_PENDING" });
        const response = await apiClient.get(
          `/api/v1/states`,
          {
            params: {
              limit: limit,
              page: page,
              search: search,
              sort: sort,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch({
          type: "GET_STATELIST_FULFILLED",
          payload: response.data?.data,
          stateCount: response.data?.pagination.total,
          permissions: response.data?.permissions,
        });
      } catch (error) {
        dispatch({
          type: "GET_STATELIST_REJECTED",
          payload: error.response,
        });
      }
    };


export const saveStateData = (token, data) => async (dispatch) => {
  try {
    dispatch({ type: "ADD_STATE_PENDING" });

    const response = await apiClient.post(
      `/api/v1/states`,
      data, // Data payload should be the second argument
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "ADD_STATE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "ADD_STATE_REJECTED", payload: error.response });
  }
};


export const getStateListById = (token, id) =>
  async (dispatch) => {
    try {
      dispatch({ type: "GET_STATELISTBYID_PENDING" });

      const response = await apiClient.get(
        `/api/v1/states/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch({
        type: "GET_STATELISTBYID_FULFILLED",
        payload: response.data?.data,
        stateCount: response.data?.count,
      });
    } catch (error) {
      dispatch({
        type: "GET_STATELISTBYID_REJECTED",
        payload: error.response,
      });
    }
  };


export const updateStateData = (token, data, id) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_STATE_PENDING" });

    const response = await apiClient.put(
      `/api/v1/states/${id}`, // Endpoint URL with vehicle ID
      data, // Data payload
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "UPDATE_STATE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "UPDATE_STATE_REJECTED", payload: error.response });
  }
};


export const deleteStateData = (token, id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_STATE_PENDING" });

    const response = await apiClient.delete(
      `/api/v1/states/${id}`, // Endpoint URL with vehicle ID
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "DELETE_STATE_FULFILLED", payload: response.data });
  } catch (error) {
    dispatch({ type: "DELETE_STATE_REJECTED", payload: error.response });
  }
};
